const 
    btnColorElement = document.querySelectorAll('.js-theme-change'),
    bodyElement = document.getElementsByTagName('body')[0],
    activeClass= (element) => {
        document.querySelector('.js-theme-change.btn--active').classList.remove('btn--active','scale-3');
        element.classList.add('btn--active','scale-3');
    },
    updateClasses = (oldClass, newClass) => {
        const allClass = document.querySelectorAll(`.${oldClass}`);
        allClass.forEach(item => {
            item.classList.remove(oldClass);
            item.classList.add(newClass);
        }) 
    },
    updatingClassList = (previousClass, newClass) => {
        updateClasses(`text-${previousClass}`, `text-${newClass}`);
        updateClasses(`text-${previousClass}-hover`, `text-${newClass}-hover`);
        updateClasses(`btn-${previousClass}`, `bg-${newClass}`);
        updateClasses(`btn-outline-${previousClass}`, `btn-outline-${newClass}`);
        updateClasses(`link-btn-hover--${previousClass}`, `link-btn-hover--${newClass}`);
        updateClasses(`absolute-border--${previousClass}`, `absolute-border--${newClass}`);
        updateClasses(`link-box-hover--${previousClass}`, `link-box-hover--${newClass}`);
    },
    transitionBlurList = (previousClass, newClass) => {
        bodyElement.classList.add('blur-1');
        setTimeout(()=> {
            bodyElement.classList.remove('blur-1');
            updatingClassList(previousClass, newClass); 
        },500);
    };

btnColorElement.forEach(item => {
    item.addEventListener('click', ()=> {
        activeClass(item);
        let previousTheme = bodyElement.getAttribute('theme'),
            currentTheme = item.getAttribute('color');
        bodyElement.setAttribute('theme',currentTheme);
        if (previousTheme !== currentTheme) {
            transitionBlurList(previousTheme, currentTheme);
        }
    })
})